<template>
  <div class="ma-0 mp-0">
    <v-menu
      ref="ymdDateMenu"
      :close-on-content-click="false"
      v-model="ymdDateMenu"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        hint="MM/DD/YYYY format"
        prepend-icon="mdi-calendar"
        @blur="date = parseDate(dateFormatted)"
        :error-messages="errorMessages"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="ymdDateMenu = false"
      :min="minDate"
      :max="maxDate"
      :show-current="true"
    />
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'ymd-datepicker',
  props: {
    value: {
      type: String,
      require: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: 'Date'
    },
    errorMessages: {
      type: Array
    },
    minDate: {
      type: String,
      require: false,
      default: null
    },
    maxDate: {
      type: String,
      require: false,
      default: null
    }
  },
  data: vm => ({
    date: null, // new Date().toISOString().slice(0, 10),
    dateFormatted: null, // vm.formatDate(new Date().toISOString().slice(0, 10)),
    ymdDateMenu: false
  }),

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    value: { // adding a watcher to the initial value seems to be the only reliable way to set the date...
      immediate: true,
      handler (newVal, oldVal) {
        this.date = newVal
      }
    },
    date (newVal, oldVal) {
      this.dateFormatted = this.formatDate(newVal)
      this.$emit('input', newVal)
      this.$emit('update:date', newVal)
    }
  },

  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>
